import { useFormContext } from 'react-hook-form'

import { FormBlockerElementCashtagElement } from '@cash-web/protos/squareup/franklin/form_blocker.pb'
import { useCurrencySymbol } from '@cash-web/shared-feature-currency-symbol'
import { CashtagInput } from '@cash-web/shared-feature-form'

export const CashtagElement = ({
  prefix_symbol,
  prefill_text,
  hint_text,
  formSectionIndex,
  elementId,
}: FormBlockerElementCashtagElement & { formSectionIndex: number; elementId?: string; shouldAutoFocus?: boolean }) => {
  const currencySymbol = useCurrencySymbol()
  const { register } = useFormContext()

  return (
    <>
      <input type="hidden" value={elementId} {...register(`${formSectionIndex}.id`)} />
      <CashtagInput
        inputPrefix={prefix_symbol}
        currencySymbol={currencySymbol}
        placeholder={hint_text}
        defaultValue={prefill_text}
        name={`${formSectionIndex}.cashtag_result.cashtag`}
        showLabel={false}
      />
    </>
  )
}
